export const APP_NAME = 'alongID';
